import React, { useState } from 'react';
import '../css/eyeButton.css';
import { scannerLogin, setScannerSession } from './scannerApi';

// Scanner-only login (email + password). Separate from the admin login page.
const ScannerLogin = ({ onLoggedIn }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const login = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      const { data } = await scannerLogin(email.trim(), password);
      setScannerSession(data.authorisation.token, data.user);
      // ask for location permission now so the scanner can check where scans are made
      try { navigator.geolocation?.getCurrentPosition(() => {}, () => {}, { timeout: 8000 }); } catch { /* not available */ }
      onLoggedIn();
    } catch (err) {
      setError(err.response?.data?.message || 'Could not sign in. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', background: '#0d6efd', padding: 16 }}>
      <div className="card shadow w-100" style={{ maxWidth: 380 }}>
        <div className="card-body p-4">
          <div className="text-center mb-4">
            <i className="fa fa-qrcode text-primary" style={{ fontSize: 48 }} />
            <h4 className="mt-2 mb-0">Accreditation Scanner</h4>
            <small className="text-muted">Gate staff login</small>
          </div>

          {error && <div className="alert alert-danger py-2">{error}</div>}

          <form onSubmit={login}>
            <label className="form-label">Email</label>
            <input type="email" className="form-control mb-3" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" required />

            <label className="form-label">Password</label>
            <div className="input-group mb-3">
              <input
                type={show ? 'text' : 'password'}
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
              <button type="button" className="btn eye-btn" onClick={() => setShow((s) => !s)} aria-label={show ? 'Hide password' : 'Show password'}>
                <i className={`fa ${show ? 'fa-eye-slash' : 'fa-eye'}`} />
              </button>
            </div>

            <button className="btn btn-primary w-100" type="submit" disabled={busy}>
              {busy ? 'Please wait…' : 'Login'}
            </button>
          </form>

          {/* Desktop view only: back to the main (admin dashboard) login */}
          <div className="d-none d-md-block text-center mt-3 pt-3 border-top">
            <a href="/" className="btn btn-outline-secondary btn-sm">
              <i className="fa fa-user-shield me-2" />
              Admin? Go to Main Login
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScannerLogin;
